import { Color } from 'jspdf-autotable';
import { keysToTranslate } from 'src/app/core/util/keys-to-translate';

export class ProtocolPdfConstants {
  public static readonly marginX = 24;
  public static readonly maxXValue = 200;
  public static readonly maxLineWidth =
    ProtocolPdfConstants.maxXValue - ProtocolPdfConstants.marginX;
  public static readonly marginYFirstPage = 11;
  public static readonly marginYFurtherPages = 30;
  public static readonly maxYValue = 280;
  public static readonly lineHeight = 4.8;
  public static readonly defaultFontSize = 11;
  public static readonly defaultFontType = 'normal';
  public static readonly tinyFontSize = 7;
  public static readonly smallFontSize = 9;
  public static readonly bigFontSize = 14;
  public static readonly boldFontType = 'bold';
  public static readonly fontType = 'helvetica';
  public static readonly italicFontType = 'italic';
  public static readonly firstColumnWidth = 47;
  public static readonly pointGroupIndentationPerLevel = 3;
  public static readonly defectsTableColumnWidthNumber = 9;
  public static readonly defectsTableColumnWidthDefect = 72;
  public static readonly defectsTableColumnWidthMeasure = 72;
  public static readonly defectsTableColumnWidthMeasureExtended =
    ProtocolPdfConstants.defectsTableColumnWidthMeasure + 43;
  public static readonly defectsTableColumnWidthGve = 25;
  public static readonly defectsTableColumnWidthDeadline =
    ProtocolPdfConstants.calculateDefectsTableColumnWidthDeadline();
  public static readonly defectsCorrectionTableColumnWidthNumber = 10;
  public static readonly defectsCorrectionTableColumnWidthDefect = 61;
  public static readonly defectsCorrectionTableColumnWidthMeasure = 58;
  public static readonly defectsCorrectionTableColumnWidthDeadline = 23;
  public static readonly defectsCorrectionTableColumnWidthCorrected =
    ProtocolPdfConstants.calculateDefectsCorrectionTableColumnWidthCorrected();
  public static readonly defectsTableMarginBetweenDefects = 1;
  public static readonly signatureBlockWidthLabel = 30;
  public static readonly signatureBlockWidthDottedLine =
    ProtocolPdfConstants.calculateSignatureBlockWidthDottedLine();
  // 284.9 mm (Footer Line) + 3.6 mm (Footer Text Basis bis Footer Line) + 8.5 mm (Seitenrand Unten CD Kanton Bern) = 297 mm (A4)
  public static readonly footerLineYValue = 284.9;
  public static readonly dateFormat = 'dd.MM.yyyy';
  public static readonly grayColor = [238, 238, 238] as Color;
  public static readonly whiteColor = [256, 256, 256] as Color;

  public constructor() {
    keysToTranslate([
      'AG_protocol_standard',
      'AG_protocol_bienen',
      'ARAI_protocol_standard',
      'ARAI_protocol_certificate',
      'BE_protocol_standard',
      'BE_protocol_dhbVertragskantone',
      'BE_protocol_email',
      'FL_protocol_standard',
      'FR_protocol_standard',
      'FR_protocol_viehhandel',
      'FR_protocol_gruyere',
      'FR_protocol_vacherin',
      'URK_protocol_standard',
      'ZH_protocol_standard',
      'ZH_protocol_standard_tnp',
      'ZH_protocol_privatepharmacies',
      'ZH_protocol_paincausingprocedures',
      'Fehler beim Laden des Bildes, pdf wird ohne Bild erzeugt',
      'Fehler beim Laden des Bildes. Bild ist leer oder Null, pdf wird ohne Bild erzeugt',
      'labelKey',
      'Gebuehr.Keine',
      'ProtocolPdf.AiArCertificateForFailCheckbox1',
      'ProtocolPdf.AiArCertificateForFailCheckbox2',
      'ProtocolPdf.AiArCertificateForFailCheckboxesTitle',
      'ProtocolPdf.AiArCertificateForSuccessCheckbox1',
      'ProtocolPdf.AiArCertificateForSuccessCheckbox2',
      'ProtocolPdf.AiArCertificateForSuccessCheckbox3',
      'ProtocolPdf.AiArCertificateForSuccessCheckboxesTitle',
      'ProtocolPdf.DefectCorrectionTableHeaderCorrected',
      'ProtocolPdf.DefectCorrectionTableHeaderDeadline',
      'ProtocolPdf.DefectCorrectionTableHeaderDeadlineUntil',
      'ProtocolPdf.DefectCorrectionTableHeaderDefect',
      'ProtocolPdf.DefectCorrectionTableHeaderMeasure',
      'ProtocolPdf.DefectCorrectionTableHeaderNr',
      'ProtocolPdf.DefectTableHeaderProposedMeasure',
      'ProtocolPdf.DefectTableHeaderDeadline',
      'ProtocolPdf.DefectTableHeaderDefect',
      'ProtocolPdf.DefectTableHeaderGve',
      'ProtocolPdf.DefectTableHeaderMeasure',
      'ProtocolPdf.DefectTableHeaderNr',
      'ProtocolPdf.FieldValues',
      'ProtocolPdf.GruyereLegendRemarks',
      'ProtocolPdf.GruyereLegendRemarksTitle',
      'ProtocolPdf.GruyereMilkProducersHeader',
      'ProtocolPdf.GruyereMilkProductionUnitHeaderPart1',
      'ProtocolPdf.GruyereMilkProductionUnitHeaderPart2',
      'ProtocolPdf.GruyereMilkProductionUnitHeaderPart3',
      'ProtocolPdf.GruyereMilkProductionUnitRow1Col1',
      'ProtocolPdf.GruyereMilkProductionUnitRow1Col2',
      'ProtocolPdf.GruyereMilkProductionUnitRow1Col3',
      'ProtocolPdf.GruyerePageFooterRow2Part1',
      'ProtocolPdf.GruyerePageHeader',
      'ProtocolPdf.GruyereRechtsformDesBetriebes',
      'ProtocolPdf.GruyereRequirementsLegendRow1',
      'ProtocolPdf.GruyereRequirementsLegendRow2Part1',
      'ProtocolPdf.GruyereRequirementsText15Part1',
      'ProtocolPdf.GruyereRequirementsText15Part2',
      'ProtocolPdf.GruyereRequirementsTextArticle3',
      'ProtocolPdf.GruyereRequirementsTextArticle16',
      'ProtocolPdf.GruyereRequirementsTextArticle7Part1',
      'ProtocolPdf.GruyereRequirementsTextArticle7Part2',
      'ProtocolPdf.GruyereRequirementsTextArticle7APart1',
      'ProtocolPdf.GruyereRequirementsTextArticle7APart2',
      'ProtocolPdf.GruyereRequirementsTextArticle9',
      'ProtocolPdf.GruyereRequirementsTextArticle10',
      'ProtocolPdf.GruyereRequirementsTitleArticle3',
      'ProtocolPdf.GruyereRequirementsTitleArticle7',
      'ProtocolPdf.GruyereRequirementsTitleArticle7A',
      'ProtocolPdf.GruyereRequirementsTitleArticle9',
      'ProtocolPdf.GruyereRequirementsTitleArticle10',
      'ProtocolPdf.GruyereRequirementsTitleArticle15',
      'ProtocolPdf.GruyereRequirementsTitleArticle16',
      'ProtocolPdf.GruyereRequirementsTextArticle11Part1',
      'ProtocolPdf.GruyereRequirementsTextArticle11Part2',
      'ProtocolPdf.GruyereRequirementsTextArticle17',
      'ProtocolPdf.GruyereRequirementsTextArticle14Part1',
      'ProtocolPdf.GruyereRequirementsTitleArticle111',
      'ProtocolPdf.GruyereRequirementsTitleArticle112',
      'ProtocolPdf.GruyereRequirementsTitleArticle113',
      'ProtocolPdf.GruyereRequirementsTitleArticle131',
      'ProtocolPdf.GruyereRequirementsTitleArticle132',
      'ProtocolPdf.GruyereRequirementsTitleArticle17',
      'ProtocolPdf.GruyereRequirementsTitleArticle121',
      'ProtocolPdf.GruyereRequirementsTitleArticle122',
      'ProtocolPdf.GruyereRequirementsTitleArticle141',
      'ProtocolPdf.GruyereRequirementsTitleArticle114',
      'ProtocolPdf.GruyereRequirementsTextArticle11Part3',
      'ProtocolPdf.GruyereRequirementsTextArticle11Part4',
      'ProtocolPdf.GruyereRequirementsTextArticle12Part1',
      'ProtocolPdf.GruyereRequirementsTextArticle12Part2',
      'ProtocolPdf.GruyereRequirementsTextArticle13Part1',
      'ProtocolPdf.GruyereRequirementsTextArticle13Part2',
      'ProtocolPdf.GruyereRequirementsTextArticle181',
      'ProtocolPdf.GruyereRequirementsTextArticle182',
      'ProtocolPdf.GruyereRequirementsTextArticle19a',
      'ProtocolPdf.GruyereRequirementsTextArticle19bc',
      'ProtocolPdf.GruyereRequirementsTextArticle233',
      'ProtocolPdf.GruyereRequirementsTextArticle23bem',
      'ProtocolPdf.GruyereRequirementsTitleArticle181',
      'ProtocolPdf.GruyereRequirementsTitleArticle19a',
      'ProtocolPdf.GruyereRequirementsTitleArticle19bc',
      'ProtocolPdf.GruyereRequirementsTitleArticle233',
      'ProtocolPdf.HeaderConfirmationDefectCorrection',
      'ProtocolPdf.HeaderAddressBe',
      'ProtocolPdf.HeaderBe1',
      'ProtocolPdf.HeaderBe2',
      'ProtocolPdf.HeaderBe3',
      'ProtocolPdf.HeaderFr1',
      'ProtocolPdf.HeaderFr2',
      'ProtocolPdf.HeaderFr3',
      'ProtocolPdf.HeaderFr4',
      'ProtocolPdf.HeaderMailAddressBe',
      'ProtocolPdf.HeaderName',
      'ProtocolPdf.HeaderPhoneNumberBe',
      'ProtocolPdf.HeaderPostalZoneBe',
      'ProtocolPdf.HeaderProtocol',
      'ProtocolPdf.HeaderReport',
      'ProtocolPdf.HeaderReportArAiCertificate',
      'ProtocolPdf.HeaderVetReport',
      'ProtocolPdf.HeaderVetReport2',
      'ProtocolPdf.HeaderWebsiteBe',
      'ProtocolPdf.HeaderZipCodeAndTownBe',
      'ProtocolPdf.LabelAbbreviations',
      'ProtocolPdf.LabelAbsent',
      'ProtocolPdf.LabelAddress',
      'ProtocolPdf.LabelBetriebZusaetzlicheAngaben',
      'ProtocolPdf.LabelBURNr',
      'ProtocolPdf.LabelCommentOfDepartment',
      'ProtocolPdf.LabelCommentOfDepartmentShort',
      'ProtocolPdf.LabelCommentOfDepartmentShortPlural',
      'ProtocolPdf.LabelControlledArea',
      'ProtocolPdf.LabelControlledLocation',
      'ProtocolPdf.LabelCount',
      'ProtocolPdf.LabelDate',
      'ProtocolPdf.NotControlledAreas',
      'ProtocolPdf.LabelDefectCorrectionRemarks',
      'ProtocolPdf.LabelDefectCorrectionRemarksUnit',
      'ProtocolPdf.LabelDocumentationOther',
      'ProtocolPdf.LabelDocumentationPhotos',
      'ProtocolPdf.LabelDocumentationPhotosAdded',
      'ProtocolPdf.LabelDuration',
      'ProtocolPdf.LabelEmail',
      'ProtocolPdf.LabelEmailD',
      'ProtocolPdf.LabelEmailSAAV',
      'ProtocolPdf.LabelErfassterWert',
      'ProtocolPdf.LabelFee',
      'ProtocolPdf.LabelFurtherAction',
      'ProtocolPdf.LabelHours',
      'ProtocolPdf.LabelInspectionID',
      'ProtocolPdf.LabelInspectionAsanID',
      'ProtocolPdf.LabelInspectionResult',
      'ProtocolPdf.LabelKTID',
      'ProtocolPdf.LabelLocation',
      'ProtocolPdf.LabelName',
      'ProtocolPdf.LabelOrderLSVW',
      'ProtocolPdf.LabelPhone',
      'ProtocolPdf.LabelPosition',
      'ProtocolPdf.LabelPostalZoneTown',
      'ProtocolPdf.LabelPrice',
      'ProtocolPdf.LabelReason',
      'ProtocolPdf.LabelSignature',
      'ProtocolPdf.LabelSignatureInspectionPerson',
      'ProtocolPdf.LabelSignatureInspectionValidWithoutSignature',
      'ProtocolPdf.LabelSignatureInspectionPersonDescriptionPrivatePharmaciesZh',
      'ProtocolPdf.LabelSignatureInspectionPersonTitlePrivatePharmaciesZh',
      'ProtocolPdf.LabelSignatureControlledPerson',
      'ProtocolPdf.LabelSignatureRejected',
      'ProtocolPdf.LabelSignatureResponsiblePerson',
      'ProtocolPdf.LabelSignatureResponsiblePersonDescriptionPrivatePharmaciesZh',
      'ProtocolPdf.LabelSignatureResponsiblePersonTitlePrivatePharmaciesZh',
      'ProtocolPdf.LabelStatement',
      'ProtocolPdf.LabelStatementUrkantone',
      'ProtocolPdf.LabelTVDNr',
      'ProtocolPdf.LabelTotal',
      'ProtocolPdf.LabelTotalChf',
      'ProtocolPdf.LabelType',
      'ProtocolPdf.LabelUnitAbsent',
      'ProtocolPdf.LabelUnitAbsentDeposit',
      'ProtocolPdf.LabelUnitAbsentDepositSimple',
      'ProtocolPdf.LabelUnitAbsentDepositMailOrLetterSimple',
      'ProtocolPdf.LabelUnitAbsentEmailSimple',
      'ProtocolPdf.LabelUnitAbsentLetter',
      'ProtocolPdf.LabelUnitAbsentLetterSimple',
      'ProtocolPdf.LabelBetriebBasisdaten',
      'ProtocolPdf.LabelUnitTnpAbsent',
      'ProtocolPdf.LabelUnitCopy',
      'ProtocolPdf.LabelUnitCopyPending',
      'ProtocolPdf.LabelUnitSendProtocol',
      'ProtocolPdf.LabelUnitFromLocation',
      'ProtocolPdf.PageNumber',
      'ProtocolPdf.SublabelInspector',
      'ProtocolPdf.SublabelInspectorD',
      'ProtocolPdf.SublabelInspectorFiller',
      'ProtocolPdf.SublabelResponsiblePerson',
      'ProtocolPdf.Statement',
      'ProtocolPdf.TextAbbreviationAln',
      'ProtocolPdf.TextAbbreviationVeta',
      'ProtocolPdf.TextAln',
      'ProtocolPdf.TextConfirmationDeadlineAiAr',
      'ProtocolPdf.TextConfirmationDeadlineAg',
      'ProtocolPdf.TextConfirmationDeadlineBe',
      'ProtocolPdf.TextConfirmationDeadlineBe.DhbVertragskantone',
      'ProtocolPdf.TextConfirmationDeadlineFl',
      'ProtocolPdf.TextConfirmationDeadlineFr',
      'ProtocolPdf.TextConfirmationDeadlineUrk',
      'ProtocolPdf.TextConfirmationDeadlineZh',
      'ProtocolPdf.TextConfirmationDefectCorrection',
      'ProtocolPdf.TextConfirmationDefectCorrectionWithDate',
      'ProtocolPdf.TextControlledCategoriesWithDefect',
      'ProtocolPdf.TextDefectsAccordingToList',
      'ProtocolPdf.TextHeaderFurtherProcedureDetails',
      'ProtocolPdf.TextHeaderFurtherProcedureDetailsArAi',
      'ProtocolPdf.TextHeaderFurtherProcedureDetailsAg',
      'ProtocolPdf.TextHeaderFurtherProcedureDetailsFl',
      'ProtocolPdf.TextHeaderFurtherProcedureDetailsUrk',
      'ProtocolPdf.TextHeaderFurtherProcedureDetailsZh',
      'ProtocolPdf.TextHeaderOptionsForComment',
      'ProtocolPdf.TextMeasureAccordingToList',
      'ProtocolPdf.TextNoDefects',
      'ProtocolPdf.TextOptionForComment1',
      'ProtocolPdf.TextOptionForComment1.DhbVertragskantone',
      'ProtocolPdf.TextOptionForComment2.DhbVertragskantone',
      'ProtocolPdf.TextOptionForComment2',
      'ProtocolPdf.TextOptionFurtherProcedureDetails1',
      'ProtocolPdf.TextOptionFurtherProcedureDetails1.DhbVertragskantone',
      'ProtocolPdf.TextOptionFurtherProcedureDetails2',
      'ProtocolPdf.TextOptionFurtherProcedureDetails2.DhbVertragskantone',
      'ProtocolPdf.TextOptionFurtherProcedureDetails3',
      'ProtocolPdf.TextOptionFurtherProcedureDetails3.DhbVertragskantone',
      'ProtocolPdf.TextOptionFurtherProcedureDetails4',
      'ProtocolPdf.TextOptionFurtherProcedureDetails4.DhbVertragskantone',
      'ProtocolPdf.TextOptionFurtherProcedureDetails5.DhbVertragskantone',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsArAi1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsArAi2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsArAi3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsArAi4',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg4',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg5',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg6',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsAg7',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFl1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFl2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFl3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFl4',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFr1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFr2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsFr3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk4',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk5',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsUrk6',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZh1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZh2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZh3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZh4',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZhTnp1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZhTnp2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsZhTnp3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh1',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh2',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh3',
      'ProtocolPdf.TextOptionFurtherProcedureDetailsPrivatePharmaciesZh4',
      'ProtocolPdf.TextOrderLSVW1',
      'ProtocolPdf.TextOrderLSVW2',
      'ProtocolPdf.TextResponsiblePersonPresent',
      'ProtocolPdf.TextResponsiblePersonPresentBeEmail',
      'ProtocolPdf.TextResponsiblePersonPresentFr',
      'ProtocolPdf.TextResponsiblePersonPresentUrk',
      'ProtocolPdf.TextStatementAgree',
      'ProtocolPdf.TextStatementCorrespontToFacts',
      'ProtocolPdf.TextStatementDisagree',
      'ProtocolPdf.TextStatementNoCorrespontToFacts',
      'ProtocolPdf.TextStatementNoRemarks',
      'ProtocolPdf.TextStatementRemarks',
      'ProtocolPdf.TextVeta',
      'ProtocolPdf.VacherinAndGruyereAuditorRequirementsHeaderCol1',
      'ProtocolPdf.VacherinAndGruyereAuditorRequirementsHeaderCol2',
      'ProtocolPdf.VacherinAndGruyereAuditorRequirementsHeaderCol3',
      'ProtocolPdf.VacherinAndGruyereNotApplicable',
      'ProtocolPdf.VacherinAndGruyereTextHeader',
      'ProtocolPdf.VacherinAndGruyereTVDHeaderCol1',
      'ProtocolPdf.VacherinAndGruyereTVDHeaderCol2',
      'ProtocolPdf.VacherinAndGruyereTVDHeaderCol3Part1',
      'ProtocolPdf.VacherinAndGruyereNotApplicable',
      'ProtocolPdf.VacherinAndGruyereUnitCanton',
      'ProtocolPdf.VacherinAndGruyereYes',
      'ProtocolPdf.VacherinAndGruyereNot',
      'ProtocolPdf.VacherinPageFooterRow2Part1',
      'ProtocolPdf.VacherinPageHeader',
      'ProtocolPdf.VacherinRequirementsArticle2Column1Row1',
      'ProtocolPdf.VacherinRequirementsArticle2Column3Row1',
      'ProtocolPdf.VacherinRequirementsArticle6Column1Row1',
      'ProtocolPdf.VacherinRequirementsArticle6Column3Row1',
      'ProtocolPdf.VacherinRequirementsArticle6Column3Row2',
      'ProtocolPdf.VacherinRequirementsArticle7Column1Row1',
      'ProtocolPdf.VacherinRequirementsArticle7Column3Row1',
      'ProtocolPdf.VacherinRequirementsArticle8Column1Row1',
      'ProtocolPdf.VacherinRequirementsArticle8Column3Row1',
      'ProtocolPdf.VacherinRequirementsArticle12Column1Row1',
      'ProtocolPdf.VacherinRequirementsArticle12Column3Row1',
      'ProtocolPdf.VacherinRequirementsLegendRow1',
      'ProtocolPdf.VacherinRequirementsLegendRow2Part2',
      'ProtocolPdf.VacherinTvdRow2Col1Part1',
      'ProtocolPdf.VacherinTvdRow2Col1Part2',
      'ProtocolPdf.VacherinTvdRow2Col1Part3',
      'ProtocolPdf.VacherinTvdRow2Col1Part4',
      'WeiteresVorgehen.AnordnungVorgesehen',
      'WeiteresVorgehen.KontrollberichtFolgt',
      'WeiteresVorgehen.NachkontrolleVorgesehen',
      'WeiteresVorgehen.RueckmeldungFormular',
      'WeiteresVorgehen.StrafanzeigeFolgt',
    ]);
  }

  private static calculateDefectsTableColumnWidthDeadline(): number {
    return (
      this.maxXValue -
      this.marginX -
      this.defectsTableColumnWidthNumber -
      this.defectsTableColumnWidthDefect -
      this.defectsTableColumnWidthMeasure
    );
  }

  private static calculateDefectsCorrectionTableColumnWidthCorrected(): number {
    return (
      this.maxXValue -
      this.marginX -
      this.defectsCorrectionTableColumnWidthNumber -
      this.defectsCorrectionTableColumnWidthDefect -
      this.defectsCorrectionTableColumnWidthMeasure -
      this.defectsCorrectionTableColumnWidthDeadline
    );
  }

  private static calculateSignatureBlockWidthDottedLine(): number {
    return (this.maxXValue - this.marginX - 2 * this.signatureBlockWidthLabel) / 2.0;
  }
}
